'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { Dispatch, SetStateAction } from 'react';
import type { User } from '@/types/user';

interface NavlinksProps {
  user: User;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
}

const Navlinks = ({ user, setIsOpen }: NavlinksProps) => {
  const pathname = usePathname();

  return (
    <>
      <Link
        href='/areas'
        data-active={pathname.includes('/areas')}
        data-access={user.features.areas}
        onClick={() => setIsOpen?.(false)}
        className={`hover:text-bui-color-orange data-[access="false"]:text-bui-color-dark-gray
          data-[active="true"]:text-bui-color-orange no-underline`}
      >
        Bostadsmarknad
      </Link>
      <a
        href='/housing-coops'
        data-access={user.features['housing-coops']}
        data-active={pathname.includes('/housing-coops')}
        className={`hover:text-bui-color-orange data-[access=false]:text-bui-color-dark-gray
          data-[active=true]:text-bui-color-orange no-underline`}
      >
        BRF
      </a>
      <a
        href='/sales'
        data-access={user.features.sales}
        data-active={pathname.includes('/sales')}
        className={`hover:text-bui-color-orange data-[access=false]:text-bui-color-dark-gray
          data-[active=true]:text-bui-color-orange no-underline`}
      >
        Bostäder
      </a>
      <a
        href='/projects'
        data-access={user.features.projects}
        data-active={pathname.includes('/projects')}
        className={`hover:text-bui-color-orange data-[access=false]:text-bui-color-dark-gray
          data-[active=true]:text-bui-color-orange no-underline`}
      >
        Bostadsprojekt
      </a>
      <Link
        href='/developers'
        data-access={user.features.developers}
        data-active={pathname.includes('/developers')}
        className={`hover:text-bui-color-orange data-[access=false]:text-bui-color-dark-gray
          data-[active=true]:text-bui-color-orange no-underline`}
        onClick={() => setIsOpen?.(false)}
      >
        Bostadsutvecklare
      </Link>
      <a
        href='/agencies'
        data-access={user.features.agencies}
        data-active={pathname.includes('/agencies')}
        className={`hover:text-bui-color-orange data-[access=false]:text-bui-color-dark-gray
          data-[active=true]:text-bui-color-orange no-underline`}
      >
        Mäklarbyråer
      </a>
      <a
        href='/agents'
        data-access={user.features.agents}
        data-active={pathname.includes('/agents')}
        className={`hover:text-bui-color-orange data-[access=false]:text-bui-color-dark-gray
          data-[active=true]:text-bui-color-orange no-underline`}
      >
        Mäklare
      </a>
      <Link
        href='/estimations'
        data-access={user.features.estimations}
        data-active={pathname.includes('/estimations')}
        className={`hover:text-bui-color-orange data-[access=false]:text-bui-color-dark-gray
          data-[active=true]:text-bui-color-orange no-underline`}
        onClick={() => setIsOpen?.(false)}
      >
        Värderingar
      </Link>
      <Link
        href='/indices'
        data-active={pathname.includes('/indices')}
        className={`hover:text-bui-color-orange data-[access=false]:text-bui-color-dark-gray
          data-[active=true]:text-bui-color-orange no-underline`}
        onClick={() => setIsOpen?.(false)}
      >
        Prisindex
      </Link>
    </>
  );
};

export default Navlinks;
